import pluralize from 'pluralize';
import { Flex, Text } from '@mantine/core';
import { Button } from 'src/design-system/Button';
import { Modal } from 'src/design-system/Modal';

type Props = {
  opened: boolean;
  count: number;
  onClose: () => void;
  onContinue: () => void;
};

export function CheckSpeakersModal({ opened, count, onClose, onContinue }: Props) {
  const speakerCount = `${count} ${pluralize('speaker', count)}`;
  const state = `${count === 1 ? 'is' : 'are'} still unidentified`;

  return (
    <Modal opened={opened} onClose={onClose} title="Check the speakers">
      <Text size="sm" c="gray.7" mt="sm">
        {speakerCount} {state}. The meeting note may attribute statements to the wrong person.
        Review them for the most accurate note, or continue and regenerate the note afterwards.
      </Text>

      <Flex justify="flex-end" align="center" gap="sm" mt="lg">
        <Button variant="secondary" size="sm" onClick={onClose}>
          Review speakers
        </Button>
        <Button variant="primary" size="sm" onClick={onContinue}>
          Continue anyway
        </Button>
      </Flex>
    </Modal>
  );
}
